<h2 mat-dialog-title>Detaljer för aspektgrupp {{ reportAspectGroupName }}</h2>
<form #form="ngForm" [formGroup]="reportAspectGroupForm" (ngSubmit)="save(true)" novalidate class="flex-col gap-1em" autocomplete="off">
  <mat-dialog-content>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Inledande kommentarer</mat-label>
        <textarea matInput rows="8" formControlName="comments"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Tidigare kommentarer</mat-label>
        <textarea matInput rows="8" formControlName="previousComments" [readonly]="true"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Poäng</mat-label>
        <input matInput formControlName="score" [readonly]="true" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Max poäng</mat-label>
        <input matInput formControlName="maxScore" [readonly]="true" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Poäng (%)</mat-label>
        <input matInput formControlName="scorePercentage" [readonly]="true" />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (hasPermissionToChange$ | async) {
      <button mat-raised-button type="submit" color="primary" title="{{'commands.SaveAndClose' | translate }}">{{ 'commands.SaveAndClose' | translate }}</button>
    }
    @if (hasPermissionToChange$ | async) {
      <button mat-raised-button type="button" (click)="save(false)" color="accent" title="{{'commands.Save' | translate }}">{{ 'commands.Save' | translate }}</button>
    }
    <button mat-raised-button type="button" (click)="cancel()">{{ 'commands.Close' | translate }}</button>
  </mat-dialog-actions>
</form>
